import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { ROUTES } from '@/components/gg/chrome'
import { useStories, useStory } from '@/hooks/useHeadlines'
import { RecordStudio } from '@/components/camera/RecordStudio'

/**
 * Record. With `?story=<id>` it is the camera and teleprompter on that story
 * (RecordStudio, Brian's record.html v3.1). Without one it opens the account's
 * last built story (Brian's round 10 audit: never another account's), or says
 * there is nothing to record yet.
 */
export function Record() {
  const [params] = useSearchParams()
  const storyId = params.get('story') ?? undefined
  if (storyId) return <RecordStory id={storyId} />
  return <RecordList />
}

function RecordStory({ id }: { id: string }) {
  const navigate = useNavigate()
  const { data: story, isLoading, error } = useStory(id)
  if (isLoading) return <div className="feed-loading">Loading…</div>
  if (error || !story) {
    return (
      <div className="feed-empty">
        <h2>That story isn’t here</h2>
        <p>It may have been removed. Choose another story to record.</p>
        <button className="gg-act" type="button" onClick={() => navigate(ROUTES.library, { replace: true })}>Choose a story</button>
      </div>
    )
  }
  return <RecordStudio key={story.id} story={story} />
}

function RecordList() {
  const { data: stories, isLoading } = useStories()
  // newest first: the last built story this account can record
  const last = (stories ?? []).find((s) => s.status !== 'skipped')
  if (isLoading) return <div className="feed-loading">Loading…</div>
  if (last) return <Navigate to={`${ROUTES.record}?story=${encodeURIComponent(last.id)}`} replace />
  return (
    <div className="record-page gg-legacy">
      <div className="feed-empty">
        <h2>Nothing built yet</h2>
        <p>Build a story from your feed, and it shows up here to record.</p>
      </div>
    </div>
  )
}
